import { render, staticRenderFns } from "./ProjectOwnerForm.vue?vue&type=template&id=7fdd09f1"
import script from "./ProjectOwnerForm.vue?vue&type=script&lang=js"
export * from "./ProjectOwnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports